import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'horaNumero',
    standalone: false
})

export class HoraPipe implements PipeTransform {
  transform(hora: any): any {
    return moment.utc(hora * 3600 * 1000).format('hh:mm a');
  }
}
